import { APIRequestSort } from 'global';
import { useQuery } from '@apollo/client';
import { DealActivityLinkType } from '@trnsact/trnsact-shared-types';

import { dealActivityApi } from './index';
import { DEFAULT_ACTIVITY_LIST_LIMIT } from '../constants';
import { DealActivityAmountQuery, DealActivityListQuery } from './types';
import { ActivityListFilters, ActivityPageTabs, ActivityType } from '../types';

interface Params {
  parentId: string;
  sorting: APIRequestSort;
  filters: ActivityListFilters;
  activityType: ActivityPageTabs;
  parentType: DealActivityLinkType;
}

export function useFetchActivityList(params: Params) {
  const { sorting, filters, parentId, parentType, activityType } = params;

  const { data, loading, error, previousData } = useQuery<DealActivityListQuery>(dealActivityApi.dealActivities, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        sorting,
        parentId,
        parentType,
        limit: DEFAULT_ACTIVITY_LIST_LIMIT,
        filters: {
          ...(filters.search ? { search: filters.search } : {}),
          ...(activityType !== ActivityPageTabs.ALL
            ? { types: [activityType] }
            : { types: Object.values(ActivityType) }),

          ...(activityType === ActivityPageTabs.CALL ? { callFilters: filters.callFilters } : {}),
        },
      },
    },
  });

  const { data: countResponse } = useQuery<DealActivityAmountQuery>(dealActivityApi.dealActivityCount, {
    variables: {
      input: {
        parentId,
      },
    },
  });

  const activityList = (data ?? previousData)?.dealActivity?.result?.list ?? [];
  const prevActivityList = previousData?.dealActivity?.result?.list ?? [];
  const activityListTotal = countResponse?.dealActivity?.result?.entity ?? 0;

  return {
    error,
    loading,
    prevActivityList,
    activityListTotal,
    activityList: activityList ?? prevActivityList,
  };
}
